<template>
    <div class="sporadicDetails">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="overflow-y: auto">
                        <el-form class="dataFormBox" :rules="rules" :inline="true" :model="dataForm">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="项目：" prop="projectId">
                                        <el-select v-model="dataForm.projectId" style="width: 100%;" placeholder="请选择项目" :disabled="true">
                                            <el-option :label="allProjectItem.name" :value="allProjectItem.id" v-for="(allProjectItem,allProjectIndex) in allProjectList" :key="'allProject'+allProjectIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合同编号：" prop="subContractId">
                                        <el-select v-model="dataForm.subContractId" style="width: 100%;" placeholder="请选择合同编号" :disabled="true">
                                            <el-option :label="subInfoItem.serialNumber" :value="subInfoItem.id" v-for="(subInfoItem,subInfoIndex) in subInfoList" :key="'subInfoItem'+subInfoIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合作单位：">
                                        <el-input v-model="dataForm.partyB" placeholder="请输入合作单位" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="合同金额：">
                                        <el-input v-model="dataForm.amount" placeholder="请输入合同金额" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label-width="180px" label="合同内容：">
                                        <el-input
                                                type="textarea"
                                                placeholder="请输入内容"
                                                v-model="dataForm.subContent"
                                                :readonly="true"
                                                maxlength="100"
                                                show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="提报人：">
                                        <el-input v-model="dataForm.userName" placeholder="请输入提报人" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="提报部门：">
                                        <el-input v-model="dataForm.userDeptName" placeholder="请输入提报部门" :readonly="true" clearable></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="零星工程对应清单号：" prop="listNo">
                                        <el-input v-model="dataForm.listNo" placeholder="请输入零星工程对应清单号"  :readonly="true"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label-width="180px" label="内部定额小组确认：" prop="confirmType">
                                        <el-select v-model="dataForm.confirmType" style="width: 100%;" placeholder="请选择内部定额小组确认" :disabled="true">
                                            <el-option :label="confirmItem.name" :value="confirmItem.id" v-for="(confirmItem,confirmIndex) in confirmList" :key="'confirmItem'+confirmIndex"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label-width="180px" label="零星工程简要描述：" prop="content">
                                        <el-input
                                                type="textarea"
                                                placeholder="请输入零星工程简要描述"
                                                v-model="dataForm.content"
                                                :readonly="true"
                                                maxlength="500"
                                                rows=10
                                                show-word-limit>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="附件" name="Tab2" style="overflow-y: auto">
                        <div class="title">零星工程量附件：</div>
                        <el-table :data="fileList"
                                  style="width: 100%; margin-bottom: 20px"
                                  size="mini"
                                  border>
                            <el-table-column type="index" width="50" label="序号"></el-table-column>
                            <el-table-column
                                    v-for="(prop, index) in tableProps"
                                    :key="index"
                                    :prop="prop.prop"
                                    :label="prop.label"
                                    :min-width="prop.width"
                            ></el-table-column>
                            <el-table-column label="操作" width="150">
                                <template slot-scope="scope">
                                    <el-button
                                            size="mini"
                                            @click="downloadFile(scope.$index, scope.row)"
                                            type="text"
                                    >下载附件</el-button>
                                    <el-button
                                            size="mini"
                                            @click="previewFile(scope.$index, scope.row)"
                                            type="text"
                                    >预览</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-if="projectInfo.approveStatus == 3 && projectInfo.confirmType == 'NEED_CONFIRM'">
                            <div class="title">内部定额小组附件：</div>
                            <upload-file
                                    :tableList="innerGroupItemsVOList"
                                    :showDelete = "false"
                                    @submit="doSubmitFiles">
                            </upload-file>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批流程" name="Tab3" style="overflow-y: auto">
                        <div v-if="approveFlag === 'currentApprove'">
                            <approveItem
                                    :itemId="contractId"
                                    :approveType="approveType"
                                    :subapproveType="subapproveType"
                                    @finishApprove="close()"
                            >
                            </approveItem>
                        </div>
                        <div v-else>
                            <approveLine
                                    :itemId="contractId"
                                    :approveType="approveType"
                            ></approveLine>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" v-if="projectInfo.approveStatus == 3 && innerGroupItemsVOList.length != 0" @click="confirmBtn()">生成确认单</el-button>
                    <el-button type="info" @click="close()">关闭</el-button>
                </div>
            </el-footer>
        </el-container>

        <el-dialog
                title="最终确认单"
                :visible.sync="isShowPrintDialog"
                width="750px"
                class="printDialog">
            <confirmationForm :projectInfo="projectInfo"></confirmationForm>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="print">打 印</el-button>
                <el-button @click="isShowPrintDialog = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import UploadFile from "./UploadFile";
    import Consts from "@/utils/consts";
    import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
    import approveItem from "@/page/approveComponents/ApproveItem";
    import {goBackApprove} from '@/page/approveComponents/approve';
    import {previewFile} from "@/utils/index.js"
    import {
        getSporadicProjectInfoService,
        insertItemsAfterAuditService,
        getAllProjectPassListService,
    } from '@/services/engineering'
    import {
        querySubInfoByProjectIdService
    } from "@/services/invoiceServices";
    import {getTempUrlService} from "@/services/allContractServices";
    import confirmationForm from './confirmationForm'
    import printJS from "print-js";
    export default {
        name: "details",
        data() {
            return {
                activeName: 'Tab1',
                sporadicType: 0, // 1-新增 2-修改
                dataForm: {
                    id: '',
                    projectId: '',
                    subContractId: '',
                    partyB: '',
                    partyBId: '',
                    amount: '',
                    subContent: '',
                    userName: '',
                    userDeptName: '',
                    listNo: '',
                    confirmType: '',
                    content: '',
                },
                projectInfo: null,
                rules: {
                    projectId: [
                        { required: true, message: '请选择项目', trigger: 'change' },
                    ],
                    subContractId: [
                        { required: true, message: '请选择合同编号', trigger: 'change' },
                    ],
                    listNo: [
                        { required: true, message: '请输入零星工程对应清单号', trigger: 'blur' },
                    ],
                    confirmType: [
                        { required: true, message: '请选择内部定额小组确认', trigger: 'change' },
                    ],
                    content: [
                        { required: true, message: '请输入零星工程简要描述', trigger: 'blur' },
                    ],
                },
                allProjectList: [],
                subInfoList: [],
                tableProps: [
                    { prop: "name", label: "文件名称", width: "200px" },
                    { prop: "uploadUserName", label: "上传者", width: "140px" },
                    { prop: "createTime", label: "上传时间", width: "140px" },
                ],
                fileList:[],
                innerGroupItemsVOList:[],
                confirmList: [{
                    name: '是',
                    id: 'NEED_CONFIRM',
                },{
                    name: '否',
                    id: 'NOT_NEED_CONFIRM',
                }],

                approveFlag: '', //审批状态
                approveType: "SPORADIC_PROJECT", //审批类型
                subapproveType: "",
                contractId: 0,

                isShowPrintDialog: false,
            }
        },
        components: {
            UploadFile,
            approveLine,
            approveItem,
            confirmationForm,
        },
        methods: {
            onActive(menuCode) {
                // this.getAllProjectPassList();
                if(this.tabRouteParam.id){
                    this.dataForm.id = this.tabRouteParam.id;
                    this.approveFlag = this.tabRouteParam
                        ? this.tabRouteParam.approveFlag
                        : "";
                    this.contractId = Number(this.tabRouteParam.id);
                    this.getSporadicDetail();
                }
            },
            getSporadicDetail(){
                let params = {
                    id: this.dataForm.id
                }
                getSporadicProjectInfoService(params).then(res => {
                    if (res.code == 10000000){
                        this.allProjectList.push({
                          id: Number(res.data.projectId),
                          name: res.data.projectName,
                        })
                        this.projectInfo = res.data;
                        this.dataForm = {
                            ... this.dataForm,
                            projectId: Number(res.data.projectId),
                            subContractId: res.data.subContractId,
                            partyB: res.data.partyB,
                            partyBId: res.data.partyBId,
                            amount: res.data.contractAmount,
                            subContent: res.data.contractContent,
                            userName: res.data.applyUserName,
                            userDeptName: res.data.applyDeptName,
                            listNo: res.data.listNo,
                            confirmType: res.data.confirmType,
                            content: res.data.content,
                        }
                        this.fileList = res.data.sporadicProjectItemsVOList;
                        this.innerGroupItemsVOList = res.data.innerGroupItemsVOList;
                        this.getSubInfoByProjectIdList();
                    }
                })
            },
            // 查询项目列表
            getAllProjectPassList(){
                getAllProjectPassListService().then( res => {
                    if(res.code == 10000000){
                        this.allProjectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 查询合同列表
            getSubInfoByProjectIdList(){
                let params = {
                    projectId: this.dataForm.projectId
                }
                querySubInfoByProjectIdService(params).then( res => {
                    if(res.code == 10000000){
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },


            //文件下载
            downloadFile(index, row) {
                let reqParam = {
                    filePath: row.resource
                };
                getTempUrlService(reqParam).then(
                    res => {
                        if (res.code == 10000000) {
                            //下载附件
                            const link = document.createElement('a');
                            // 这里是将链接地址url转成blob地址，
                            fetch(res.data).then(res => res.blob()).then(blob => {
                                link.href = URL.createObjectURL(blob)
                                // 下载文件的名称及文件类型后缀
                                link.download = row.name;
                                document.body.appendChild(link)
                                link.click()
                                //在资源下载完成后 清除 占用的缓存资源
                                window.URL.revokeObjectURL(link.href);
                                document.body.removeChild(link);
                            });
                            // exportExcelService2(res.data).then(res1 => {
                            //   this.$alert("下载成功", "提示", {
                            //     confirmButtonText: "确定"
                            //   });
                            // });
                        } else {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$alert("系统异常", "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                );
            },
            //文件预览
            previewFile,
            doSubmitFiles(files) {
                let list = [];
                files.map(item => {
                    if(this.projectInfo.innerGroupItemsVOList.findIndex(innerItem=> innerItem.name == item.name) == -1){
                        list.push({
                            ...item,
                            sporadicProjectId: this.dataForm.id
                        })
                    }
                })
                insertItemsAfterAuditService(list).then(res => {
                    if(res.code == 10000000){
                        this.innerGroupItemsVOList = files;
                    }
                })
            },
            confirmBtn(){
                this.isShowPrintDialog = true;
            },
            print(){
                printJS({
                    printable: "HTMLSendContent",
                    type: "html",
                    targetStyles: ["*"],
                    ignoreElements: ["no-print", "bc", "gb"],
                    scanStyles: false,
                });
            },
            close(){
                if(this.approveFlag){
                    goBackApprove(this.approveFlag,'sporadicDetail')
                }else{
                    this.bus.$emit("tabClose", "sporadicDetail");
                    this.bus.$emit("navMenuChange", {
                        routeId: "sporadicIndex"
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .sporadicDetails {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
        /deep/.el-table{
            flex: none;
        }
        .printDialog{
            /deep/.el-dialog__body{
                padding: 0 20px;
            }
        }
    }
    .title {
        font-size: 20px;
        font-weight: 600;
        margin: 20px 0;
    }
    .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
            height: 100%;
            overflow: hidden;

            .el-tabs__content {
                height: calc(100% - 80px) !important;
                padding: 0 20px 20px;
                overflow: auto;
                .el-tab-pane{
                    height: calc(100% - 80px) !important;
                }

                .el-form-item {
                    width: 100%;
                }

                .el-checkbox {
                    line-height: 40px;
                }

                .el-textarea {
                    min-width: 0px !important;
                }
                .el-cascader {
                    width: 100%;
                }

                .el-form-item__content {
                    width: calc(100% - 180px);

                    .el-input {
                        width: 100%;
                    }
                }
            }
        }
    }
    /deep/.el-container .el-main{
        height: 100%;
    }
    /deep/.el-textarea{
        /*width: 600px;*/
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        background-color: #fff !important;
        color: #606266 !important;
    }
    .sendList {
        /deep/.el-form-item{
            width: 100%;
            display: flex;
            .el-form-item__content {
                width: 70%;
                display: flex;
                .el-input {
                    flex: 1;
                }
                .el-button {
                    margin-left: 10px;
                    height: fit-content;
                }
            }
        }

        .tag-wrapper {
            border: 1px solid #dcdfe6;
            padding: 0 5px;
        }
    }
    .formItem{
        /deep/.el-form-item{
            display: flex;
            align-items: flex-start;
            .el-tree-node__content{
                padding-top: 6px;
            }
        }
    }

    .containerBox {
        width: 100%;
        height: 36px !important;
        position: fixed;
        bottom: 44px;
        left: 0;
        text-align: start;
    }
    .btnMid {
        position: relative;
        left: 27%;
        bottom: 0px;
        display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
        bottom: 44px;
        z-index: 10;
    }
</style>
